import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Resources() {
  return (
    <ImageCollectionPage 
      title="Resources" 
      path="/resources" 
      collection="resources" 
    />
  );
}
